class CartDrawer extends MenuDrawer {
  constructor() {
    super();

    this.bindOnMenuDrawerOpen();
//
  }

  connectedCallback () {
    window.addEventListener('load', (event) => {
      document.querySelector('cart-drawer').OnMenuDrawerOpen();
    });
  }

  bindOnMenuDrawerOpen() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', () => {
        if (this.querySelector('#drawer-cart-items').childElementCount == 0) {
          this.OnMenuDrawerOpen.bind(this);
        }
    }))
    if (window.location.search && window.location.search.includes('?cart=open')){
      this.forceOpenDrawer();
    }
  }

  OnMenuDrawerOpen () {
    //For Langify to translate the cart
    let lang = '/';
    let currentURL = window.location.pathname;
    let currentLang = currentURL.includes('/en')
    if(currentLang){
      lang = '/en/';
    }

    const sectionsURL = lang + "?sections=" + this.getSectionsToRender().map((section) => section.id).join(',');
    console.log(sectionsURL);
    fetch(sectionsURL)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        var sections = { sections: response };
        this.renderContents(sections);
        console.log(sections);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        console.log('request done successfully');
      });
  }

  renderContents(parsedState, forceDrawerOpen = false) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      // if (this.header) this.header.reveal();
      // this.open();
      if (forceDrawerOpen) {
        this.forceOpenDrawer(forceDrawerOpen);
      }
      // trigger automatic discount custom event
      const customEvent = new CustomEvent('check-automatic-discount');
      document.dispatchEvent(customEvent);
  }
  forceOpenDrawer(type) {
    const scrollPosition = window.scrollY;
    console.log("type: ", type)
    // Open the drawer
    this.querySelector('summary')?.click();
    if(type == 'table'){
      window.scrollTo(0, scrollPosition);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'drawer-cart-items'
      },
      {
        id: 'drawer-cart-footer'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'bundle-upsell-popups'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);
